<style lang="less" scoped>
    .search-input{
        display: inline-block;
        width: 180px;
    }

    .fixed() {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        background: white;
    }

    .table {
      height: 100%;
      
      /deep/.v-data-table__wrapper  {
        height: 100%;
        overflow: auto;
        table {
          thead tr {
            th {
              padding: 8px 0;
              font-size: 0.5rem;
            }
            th:nth-child(2) {
              left: 40px;
            }
            th:nth-child(3) {
              left: 140px;
              border-right: 1px solid rgba(0,0,0,.12);
            }
            th:nth-last-child(2) {
              right: 180px;
            }
            th:nth-last-child(3) {
              right: 260px;
              border-left: 1px solid rgba(0,0,0,.12);
            }
          }
          tbody tr {
            td {
              padding: 3px 6px;
              font-size: 0.5rem;
            };
            td:nth-child(-n+3), td:nth-last-child(-n+3){
              .fixed
            }
            td:nth-child(2) {
              left: 40px;
            }
            td:nth-child(3) {
              left: 140px;
              border-right: 1px solid rgba(0,0,0,.12);
            }
            td:nth-last-child(1) {
              right: 0;
            }
            td:nth-last-child(2) {
              right: 180px;
            }
            td:nth-last-child(3) {
              right: 260px;
              border-left: 1px solid rgba(0,0,0,.12);
            }
          }
        }
        th.fixed, td.fixed {
          .fixed
        }
        th.fixed-right, td.fixed-right {
          right: 0;
        }
      }
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <Editor
        ref="editor"
        class="mx-2"
        type="primary"
        @on-change="updateInvoice"
      />
      <Upload
        class="mx-2 d-inline-block"
        :show-upload-list="false"
        :before-upload="beforeUpload('invoice')"
        :on-progress="uploadFileProgress('invoice')"
        :on-success="uploadFileOk('invoice')"
        :on-error="uploadFileFail('invoice')"
        :max_size="1024*8"
        :with-credentials="true"
        :action="ocr_invoice_path"
      >
        <Button
          type="primary"
          icon="ios-cloud-upload"
          :loading="uploading.invoice"
        >
          上传发票
        </Button>
      </Upload>
      <Upload
        class="mx-2 d-inline-block"
        :show-upload-list="false"
        :before-upload="beforeUpload('audit')"
        :on-progress="uploadFileProgress('audit')"
        :on-success="uploadFileOk('audit')"
        :on-error="uploadFileFail('audit')"
        :with-credentials="true"
        name="data_file"
        :action="ocr_audit_path"
      >
        <Button
          type="primary"
          :loading="uploading.audit"
        >
          认证发票
        </Button>
      </Upload>
      <Select
        v-model="params.validation"
        placeholder="发票验真状态"
        style="width: 120px"
        @on-change="search"
      >
        <Option
          v-for="item in invoice_status_fields "
          :key="item.value"
          :value="item.value"
          :class="item.class"
        >
          {{ item.title }}
        </Option>
      </Select>
      <Select
        v-model="params.order_sort"
        placeholder="发票录入时间"
        style="width: 120px"
        @on-change="search"
      >
        <Option
          v-for="item in invoice_date_fields "
          :key="item.value"
          :value="item.value"
        >
          {{ item.title }}
        </Option>
      </Select>
      <Select
        v-model="params.audit"
        placeholder="审核状态"
        style="width: 120px"
        @on-change="search"
      >
        <Option
          v-for="item in audit_status_fields "
          :key="item.value"
          :value="item.value"
        >
          {{ item.title }}
        </Option>
      </Select>
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="搜索发票..."
          @on-enter="search"
        />
      </div>
      <Button
        type="primary"
        icon="ios-search"
        :loading="loading"
        @click="search"
      >
        搜索
      </Button>
      <!-- invoice_print -->
      <Button
        v-if="dis_print.invoice_print"
        type="primary"
        style="margin-left:10px"
        @click="goToPrint"
      >
        打印/导出面单
      </Button>
    </div>
    <!-- <Table
      size="small"
      border
      :columns="columns"
      :data="invoices"
      :loading="loading || deleting"
    /> -->
    <v-data-table
      ref="invoice_table"
      class="table"
      style="width:100%"
      :headers="invoice_table_headers"
      :items="invoices"
      :loading="loading || deleting"
      :items-per-page="Infinity"
      loading-text="数据加载中..."
      hide-default-footer
    >
      <template v-slot:item.id="{ value }">
        <ViewerItem
          type="Invoice"
          :model_id="value"
          class="link"
        >
          查看
        </ViewerItem>
      </template>
      
      <template v-slot:item.code="{ item, value }">
        <span :class="{ 'error--text': item.del }">
          {{ value + (item.del ? '已废弃' : '') }}
        </span>
      </template>
      <template v-slot:item.invoice_form="{ value }">
        <span>
          {{ invoiceStatus(value) }}
        </span>
      </template>
      <template v-slot:item.invoice_type="{ value }">
        <span :class="{ 'error--text': [0, 1, 2].indexOf(value) == -1 }">
          {{ invoiceType(value) }}
        </span>
      </template>
      <template v-slot:item.payment_type="{ value }">
        {{ getPaymentType(value) }}
      </template>

      <template v-slot:item.total_price="{ value }">
        <div class="text-right">
          {{ formatPrice(value) }}
        </div>
      </template>

      <template v-slot:item.pretax_price="{ value }">
        <div class="text-right">
          {{ formatPrice(value) }}
        </div>
      </template>

      <template v-slot:item.tax="{ value }">
        <div class="text-right">
          {{ formatPrice(value) }}
        </div>
      </template>

      <template v-slot:item.tax_rate="{ value }">
        <div>
          {{ formatPrice(value) }}
        </div>
      </template>

      <template v-slot:item.invoice_file_id="{item, value}">
        <InvoicePicture
          v-if="value"
          :invoice_id="item.id"
        />
        <div v-else>
          -
        </div>
      </template>

      <template v-slot:item.created_at="{value}">
        {{ $util.formatDate(value) }}
      </template>

      <template v-slot:item.audited="{item, value}">
        <span v-if="item.related_BX || item.del">-</span>
        <span v-else>
          {{ audit_status_hash[value] }}
        </span>
      </template>

      <template v-slot:item.operate="{item}">
        <v-btn
          small
          outlined
          color="indigo"
          @click="$refs.editor.edit(item)"
        >
          编辑
        </v-btn> 
      
        <v-btn
          v-if="!item.del"
          small
          outlined
          class="ml-2"
          color="error"
          @click="{
            $Modal.confirm({
              title: '提示',
              content: '你确定要删除吗?',
              onOk: () => {
                del(item);
              }
            })
          }"
        >
          废弃
        </v-btn>
      </template>
    </v-data-table>
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/invoice/index">
  import Editor from './components/invoice_editor';
  import InvoicePicture from './components/invoice_picture';
  import ViewerItem from '../components/viewer/item';
  import InvoiceUtil from './libs/util';
  import { invoice_table_headers, invoice_status_fields, invoice_date_fields, audit_status_fields, getPaymentType} from './fields'
  // import FileUploader from '../components/file/uploader';
  export default {
    /* router_info_start */
    router_info: '/invoice/index',
    /* router_info_end */

    components: { Editor, ViewerItem, InvoicePicture },
    data() {
      return {
        invoice_table_headers,
        invoice_status_fields, 
        invoice_date_fields, 
        audit_status_fields,
        audit_status_hash: audit_status_fields.reduce((total, item) => {
          total[item.value] = item.title
          return total
        }, {}),
        ocr_invoice_path: this.$util.api.ocr_invoice,
        ocr_audit_path: this.$util.api.ocr_audit,
        uploading: {
          audit: false,
          invoice: false
        },
        // uploading: false,
        // ocr_invoice_path: this.$util.api.ocr_invoice,
        params: {
          page: 1,
          search: '',
          per_page: 20,
          validation: 'all',
          order_sort: 'desc',
          audit: 'all'
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        loading: false,
        deleting: false,
        invoices: [],
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      dis_print() {
        /* invoice_print */
        const current_hash = this.$store.state.hash_authority || {}
        return {
          invoice_print:current_hash['invoice_print'],
          invoice_audit:current_hash['invoice_audit'],
        }
      }
    },
    created() {
      this.search();
    },
    mounted() {
      //
    },
    methods: {
      invoiceStatus(val) {
        let str = '-'
        switch (val) {
        case 'electronic':
          str = '电子'
          break;
        case 'paper':
          str = '纸质'
          break;
                
        default:
          break;
        }
        return str 
      },
      invoiceType: InvoiceUtil.getInvoiceType,
      formatPrice: Util.formatPrice,
      getPaymentType: getPaymentType,
      beforeUpload(type) {
        switch (type) {
        case 'invoice':
          return (file) => {
            if (file.name.indexOf('%') > -1) {
              this.$Modal.error({
                title: '提示',
                content: '文件名不能包含百分号%'
              });
              return false;
            }
            this.$emit('start');
            return true;
          }
        case 'audit':
          return (file) => {
            if (!['xls', 'xlsx'].some(item => file.name.includes(item))) {
              this.$Modal.error({
                title: '提示',
                content: '文件格式必须是xls或xlsx'
              });
              return false;
            }
            return true
          }
        default:
          break;
        }
      },
      uploadFileProgress(type) {
        return () => {
          this.uploading[type] = true
        }
      },
      uploadFileOk(type) {
        switch (type) {
        case 'invoice':
          return (res, file, fileList) => {
            this.uploading.invoice = false;
            if (res.code === 1) {
              const invoices = res.data.invoices
              if (invoices.length) {
                invoices.forEach((invoice) => {
                  this.$util.insertOrUpdateArrayItem(this.invoices, invoice, true);
                });
                this.$Message.success('上传并识别成功');
              } else {
                this.$Message.error('未生成有效的发票');
              }
            } else {
              this.$Modal.error({title: '提示', content: res.msg});
            }
          }
        case 'audit':
          return (res) => {
            this.uploading.audit = false;
            if (res.code === 1) {
              const failArr = res.data || []
              if (failArr.length !== 0) {
                this.$Modal.warning({
                  title: '<p>提示', content: `${res.msg} </p>
                                       ${failArr.map(item => `<p>序号：${item.no}，${item.cause}</p>`).join('')}`
                })
              } else {
                this.$Message.success(res.msg)
              }
            } else {
              this.$Modal.error({title: '提示', content: res.msg});
            }
          }
        default:
          break;
        }
      },
      uploadFileFail(type) {
        return (error, file, fileList) => {
          this.uploading[type] = false;
          const msg = `<p>${error.message}</p>`;
          /* msg += `<p>如果 macOS 系统频繁上传失败, 可尝试关闭支付宝插件.</p>`;
                        msg += `<p>步骤如下:</p>`;
                        msg += `<p> 1. 打开终端命令行程序</p>`;
                        msg += `<p> 2. 输入: sudo launchctl remove com.alipay.DispatcherService</p>`;
                        msg += `<p> 3. 如果提示输入密码, 请输入电脑开机密码.</p>`; */
          this.$Modal.error({
            title: '上传失败',
            content: msg
          });
        }
      },
      queryInvoice() {
        this.loading = true;
        Util.ajax.get(Util.api.query_invoice, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            this.invoices = data.invoices;
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.loading = false;
          this.$Modal.warning({title: '错误', content: e.message});
        });
      },
      search() {
        this.params.page = 1;
        this.queryInvoice();
      },
      pageChange(page) {
        this.params.page = page;
        this.queryInvoice();
      },
      updateInvoice(invoice) {
        this.$util.insertOrUpdateArrayItem(this.invoices, invoice, true);
      },
      // 审核通过
      check(row, type) {
        this.$set(row, '_loading', true)
        Util.ajax.post('/invoice/audit', {id:row.id, audited:type}).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            Object.keys(row).forEach(key => {
              row[key] = res.data.invoice[key] || row[key]
            })
            this.$Message.success(type === 'has_audited' ? '审核通过！' : '审核状态已置为处理中');
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          row._loading = false
        });
      },
      del(invoice) {
        if (this.deleting) return;
        this.deleting = true;
        Util.ajax.post(Util.api.delete_invoice, invoice).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.$util.insertOrUpdateArrayItem(this.invoices, res.data.invoice);
            this.$Message.success('删除成功');
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.deleting = false;
        });
      },
      goToPrint() {
        this.$router.push(`/invoice/invoice_print?rt=${+new Date()}`)
      }
    }
  }
</script>
